import React, { Component } from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { withStyles } from '@material-ui/core/styles';
import logo from '../../images/FreightLegendWhite.png'; // relative path to image
import { ReactComponent as Vectors } from '../../images/Vectors.svg';
import Grid from '@material-ui/core/Grid';
import { REACT_APP_BASE_PATH } from '../../env';
import { compose } from 'recompose';
import { withFirebase } from '../../components/Firebase';
import { signOut, EmailAuthProvider } from 'firebase/auth';

const styles = (theme) => {
  return {
    background: {
      backgroundColor: theme.palette.primary.main,
      height: '100%',
      position: 'fixed',
      top: '0px',
      bottom: '0px',
      left: '0px',
      right: '0px',
      textAlign: 'center',
    },
    logo: {
      marginBottom: theme.spacing(2),
      maxWidth: '220px',
    },
    vectors: {
      position: 'absolute',
      left: '0px',
      right: '0px',
    },
  };
};

class SignInPage extends Component {
  constructor(props) {
    super(props);
    const { firebase } = props;
    signOut(firebase.auth);
    // Configure FirebaseUI.
    this.uiConfig = {
      // Popup signin flow rather than redirect flow.
      signInFlow: 'popup',
      credentialHelper: 'none', // disable the accountchooser page
      // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
      signInSuccessUrl: REACT_APP_BASE_PATH,
      // We will display Google and Facebook as auth providers.
      signInOptions: [
        EmailAuthProvider.PROVIDER_ID,
        // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        // firebase.auth.FacebookAuthProvider.PROVIDER_ID
      ],
    };
  }

  render() {
    let { classes, firebase } = this.props;

    return (
      <Grid container justifyContent="center" alignItems="center" className={classes.background}>
        <Grid item>
          <Vectors className={classes.vectors} />
          <img src={logo} alt="Freight Legend" className={classes.logo} />
          <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth} />
        </Grid>
      </Grid>
    );
  }
}

// export default withStyles(styles)(SignInPage);
export default compose(withStyles(styles), withFirebase)(SignInPage);
